/**
 * Central route path constants used across all route files.
 * Use these in Routes to keep paths in sync and avoid typos.
 */

// --- Moderator ---
export const MODERATOR = {
  BASE: '/moderator',
  VIDEOCHATS: '/moderator/videochats',
  SCREEN: '/moderator/screen/:roomId',
  MULTI: '/moderator/multi/:roomId',
  POLL: '/moderator/poll/:roomId',
  POLL_RESULTS: '/moderator/pollresults/:pollId',
  TOPLIST: '/moderator/toplist/:roomId',
  BREAKOUT_FORUM: '/moderator/breakoutforum/:entityListId',
  FORUM_REPLIES: '/moderator/forumreplies/:discussionId',
  QUIZ_SCREEN: '/moderator/quizscreen/:roomId',
  ASK: '/moderator/ask/:roomId',
  PINNED: '/moderator/pinned/:roomId',
  LIST: '/moderator/list/:entityListId',
  ROOM: '/moderator/:roomId/*',
};

// --- Site ---
export const SITE = {
  RESET: 'reset/:type/:id',
  VERIFY: 'verify/:verificationId',
  AUTOLOGIN: 'autologin/:tokenid',
  PROFILE_EDIT: 'profile/edit',
  PROFILE_ACCOUNT: 'profile/account',
  PROFILE_NOTIFICATIONS: 'profile/notifications/',
  PROFILE_ID: 'profile/:id',
  ASK: 'ask/:id',
};

// --- Broadcast ---
export const BROADCAST = {
  CONFERENCE: '/conference/:conferenceId',
};

// --- Live (baseName = '/live') ---
export const LIVE_BASE = '/live';
export const LIVE = {
  BASE: '/live',
  POLL: '/live/poll',
  DISCUSSION: '/live/discussion',
  DISCUSSION_IMAGES: '/live/discussionimages/:discussionId',
  DISCUSSION_TOPIC: '/live/discussion/:topic',
  PARTICIPANTS: '/live/participants',
  EXPO: '/live/collections',
  MEET: '/live/meet',
  ITEM: '/live/item/:entityId',
  ITEM_SLIDESHOW: '/live/item/:entityId/slideshow',
  LIST: '/live/list/:entityListId',
  LIST_ITEM: '/live/list/:entityListId/item/:entityId',
  LIST_ITEM_SLIDESHOW: '/live/list/:entityListId/item/:entityId/slideshow',
  ROOM: '/live/room/:roomId',
  SESSION_ROOM: '/live/session/room/:roomId',
  SESSION: '/live/session/:eventId',
};

// --- Manager ---
export const MANAGER = {
  RESET: 'reset/:type/:id',
  CONFERENCE: 'conference/:conferenceId/*',
  UPCOMING: 'upcoming',
  ORG_MENU: 'org/:id/:menu',
  ORG: 'org/:id',
  MANAGE_ORGS: 'manageorgs',
  MY_TODOS: 'mytodos',
  // FORUM_ACTIVITY: 'forumactivity',
  LIVESTREAMS: 'livestreams',
  VIDEOS: 'videos',
  DASHBOARD: '',
  THIRD_PARTY_INTEGRATIONS: 'thirdpartyintegrations',
};

// --- Manager Conference (nested under manager, relative paths) ---
export const MANAGER_CONFERENCE = {
  DASHBOARD: 'dashboard',
  GENERAL_SETTINGS: 'project-setup/general-settings',
  INTEGRATIONS: 'project-setup/integrations',
  MEDIA_LIBRARY: 'content/media-library',
  MEDIA_LIBRARY_MENU: 'content/media-library/:menu',
  CONTENT_PROGRAM: 'content/program',
  CONTENT_COLLECTIONS: 'content/collections',
  PROGRAM_ROOM_DOWNLOAD_ASSETS: 'program-room-download-assets/:roomId',
  PARTICIPANTS: 'participants-communications/participants',
  MANAGER_PARTICIPANTS_TAGS: 'participants-communications/tags',
  LIST_OF_PARTICIPANTS: 'participants-communications/lists',
  EMAILS: 'participants-communications/emails',
  NEW_EMAIL: 'participants-communications/newemail/:templateType',
  EDIT_TEXT: 'participants-communications/edittext/:templateType',
  EMAIL: 'participants-communications/email/:notificationId',
  ANALYTICS_REPORTS: 'analytics-reports',
  BREAKOUT_ROOMS: 'interactivity-engagement/breakout-rooms',
  MINGLE_ROOMS: 'interactivity-engagement/videos/mingle-rooms',
  MANAGER_POLLS: 'interactivity-engagement/polls',
  MORE_INTERACTIVITY: 'interactivity-engagement/more-interactivity',
  CONTENT_PAGES: 'content/pages',
  CONTENT_PAGE_EDIT: 'content/pages/:pageId',
  INVOICE: 'invoice',
  INVOICE_MENU: 'invoice/:menu',
  SETTINGS: 'settings',
};
